







































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_desarrollo_economicos from '@/mixins/axios/poa_desarrollo_economicos'

//@ts-ignore
//import indicador_mes_frecuencias from '@/mixins/axios/indicador_mes_frecuencias'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import SocialesHeader from '@/components/headersSelect/finalidades'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    SocialesHeader,
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
 

        columnasd:[
           
            
        {
                tag:'clave',
                data:'clave',
                active:true
            }, 
            {
                tag:'nombre',
                data:'nombre',
                active:true
            },   
                
                {
                tag:'descripcion',
                data:'descripcion',
                active:true
            }, 
            
             {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            ],



//indicador_mes_frecuencias:false,


        id:null as any,

      nombre:'' as any,
  clave:'' as any,  descripcion:'' as any,
         
         iddesarrollosocial:null,
              poa_desarrollo_economicos:[] as any,
        idgobierno:null,
              //indicador_mes_frecuencias:[] as any,
            
      
    }
  },
     mixins: [poa_desarrollo_economicos],
     validations: {
    
           nombre: {
      required,
    },
   
           clave: {
      required,
    },
           descripcion: {
      required,
    },
   
  },





  methods:{
             clearstate(){
this.$store.commit('SETGOBIERNO',null);
this.$store.commit('SETSOCIALES',null);
 this.$router.push('/mun/poas/conac/gobierno/sociales')
        },

       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_DESARROLLO_ECONOMICOS(row).then(response => {

                    if (response != null) {

 this.poa_desarrollo_economicos=this.poa_desarrollo_economicos.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
      
                 this.nombre=null;

                 this.clave=null;
         this.descripcion=null;


      },
      addRow(){
          this.limpiar();
 $('#ac_modal_poa_desarrollo_economicos').modal('show')
      },
seteditar(row){

 this.id=row.id;
 this.nombre=row.nombre;

      this.clave=row.clave; this.descripcion=row.descripcion;    
                            
          
 $('#ac_modal_poa_desarrollo_economicos').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_DESARROLLO_ECONOMICOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_desarrollo_economicos.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador areas, refresque la pagina");

                    }    $("#ac_modal_poa_desarrollo_economicos").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_DESARROLLO_ECONOMICOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Finalidad modificada correctamente.");
  this.poa_desarrollo_economicos=this.poa_desarrollo_economicos.filter(item => item.id !== dat.id);
 this.poa_desarrollo_economicos.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
           nombre:this.nombre, 
             clave:this.clave, 
               descripcion:this.descripcion, 
            idmunicipio:this.$store.state.user.usuario.id_municipio,
      idgobierno:this.$store.state.gobierno_sel.id,
         iddesarrollosocial:this.$store.state.sociales_sel.id,
}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio,
      idgobierno:this.$store.state.gobierno_sel.id,
               iddesarrollosocial:this.$store.state.sociales_sel.id,
};

let data= await this.GET_POA_DESARROLLO_ECONOMICOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_desarrollo_economicos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    } 
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
/*},
async getDataMesFrecuencia() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data={
finalidad:this.sociales_sel.id,
/*mes:this.sociales_sel.id,
abreviacion:this.sociales_sel.id,
num_mes:this.sociales_sel.id,
idmunicipio:this.$store.state.user.usuario.id_municipio




};*/

/*let data= await this.GET_INDICADOR_MES_FRECUENCIA(data).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        

this.mes=response;
this.abreviacion=response;
this.num_mes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });*/
}

 
  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

